import React, { useCallback, useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useOnSelectionChange } from '@xyflow/react'
import SydButton from '../../../commonDesign/Button'
import Icon from '../../../atoms/Icon'
import { ICON_NAMES } from '../../../../constants'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import { NodeSettings } from './NodeSettings'
import { EdgeSettings } from './EdgeSettings'

const useStyles = makeStyles({
  toggleButton: {
    position: 'absolute',
    top: 6,
    right: 6,
    zIndex: 103,
    transform: 'translate(0, 0)',
    transition: 'transform 0.3s ease-in-out'
  },
  innerContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '500px',
    background: 'color-mix(in srgb, var(--theme-color-surface-d0) 70%, transparent)',
    borderRight: 'var(--border-primary-thin)',
    padding: 'var(--padding-md)',
    boxShadow: 'var(--shadow-md)',
    backdropFilter: 'blur(10px)',
    zIndex: 101,
    transform: 'translate(-100%, 0)',
    transition: 'transform 0.3s ease-in-out',
    overflowY: 'scroll',
    '&.open': {
      transform: 'translate(0, 0)'
    }
  }
})

export const StyleEditSidebar = () => {
  const classes = useStyles()
  const { state: { styleEditItem }, dispatch } = useEntityGraphContext()
  const displaySettings = useMemo(() => !!styleEditItem, [styleEditItem])

  const onChange = useCallback(({ nodes, edges }) => {
    if (nodes?.length === 1 && !!styleEditItem) {
      return dispatch({
        type: 'TOGGLE_EDIT_SIDEBAR',
        payload: {
          path: 'styleEditItem',
          value: {
            id: nodes[0].id,
            type: 'node'
          }
        }
      })
    }
    if (edges?.length) {
      return dispatch({
        type: 'TOGGLE_EDIT_SIDEBAR',
        payload: {
          path: 'styleEditItem',
          value: {
            id: edges[0].id,
            type: 'edge'
          }
        }
      })
    }
    if (!nodes?.length && !edges?.length) {
      return dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'styleEditItem', value: null } })
    }
  }, [dispatch, styleEditItem])

  useOnSelectionChange({
    onChange
  })

  const onClose = useCallback(() => {
    dispatch({ type: 'TOGGLE_EDIT_SIDEBAR', payload: { path: 'styleEditItem', value: null } })
  }, [dispatch])

  return (
    <div className={classes.container} id='selectedSidebar'>
      <div className={clsx(classes.innerContainer, { open: displaySettings })}>
        <SydButton
          className={clsx(classes.toggleButton, { open: displaySettings })}
          onClick={onClose}
        >
          <Icon name={ICON_NAMES.close} size='md' />
        </SydButton>
        <h2 className='text-lg font-bold m-0'>Style Settings</h2>
        {styleEditItem?.type === 'node' && (
          <div key={styleEditItem?.id} className='mb-4'>
            <NodeSettings nodeId={styleEditItem?.id} />
          </div>
        )}
        {styleEditItem?.type === 'edge' && (
          <div key={styleEditItem?.id} className='mb-4'>
            <EdgeSettings edgeId={styleEditItem?.id} />
          </div>
        )}
      </div>
    </div>
  )
}
